export default __webpack_public_path__ + "static/media/hht1_ep8_minisitcom_02.57d213bf.png";